import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  return <section className="py-20 bg-amber-50" data-id="element-236">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-237">
        <div className="text-center mb-12" data-id="element-238">
          <h2 className="text-3xl font-bold text-stone-900 mb-4" data-id="element-239">
            Real Women. Real Results.
          </h2>
          <div className="flex justify-center gap-1" data-id="element-240">
            <Star className="w-6 h-6 text-amber-500 fill-current" data-id="element-241" />
            <Star className="w-6 h-6 text-amber-500 fill-current" data-id="element-242" />
            <Star className="w-6 h-6 text-amber-500 fill-current" data-id="element-243" />
            <Star className="w-6 h-6 text-amber-500 fill-current" data-id="element-244" />
            <Star className="w-6 h-6 text-amber-500 fill-current" data-id="element-245" />
          </div>
          <p className="text-stone-600 mt-2" data-id="element-246">
            4.9/5 Average Rating from Beta Testers
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-247">
          {/* Testimonial 1 */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-amber-100" data-id="element-248">
            <div className="flex gap-1 mb-4" data-id="element-249">
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-250" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-251" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-252" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-253" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-254" />
            </div>
            <p className="text-stone-700 mb-6 italic" data-id="element-255">
              "I lost{' '}
              <strong className="text-stone-900" data-id="element-256">
                2 inches off my waist in 5 days
              </strong>
              —without cutting calories. The bloating that plagued me for 3
              years is <strong className="text-stone-900" data-id="element-257">GONE.</strong>"
            </p>
            <div className="flex items-center gap-3" data-id="element-258">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center font-bold text-amber-700" data-id="element-259">
                S
              </div>
              <div data-id="element-260">
                <p className="font-bold text-stone-900" data-id="element-261">Sarah M.</p>
                <p className="text-xs text-stone-500" data-id="element-262">Age 52, Miami</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-amber-100" data-id="element-263">
            <div className="flex gap-1 mb-4" data-id="element-264">
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-265" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-266" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-267" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-268" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-269" />
            </div>
            <p className="text-stone-700 mb-6 italic" data-id="element-270">
              "By day 3, my jeans fit again. By day 7,{' '}
              <strong className="text-stone-900" data-id="element-271">
                my husband noticed my face looked less puffy.
              </strong>{' '}
              This is the first thing that's actually worked since menopause
              hit."
            </p>
            <div className="flex items-center gap-3" data-id="element-272">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center font-bold text-amber-700" data-id="element-273">
                J
              </div>
              <div data-id="element-274">
                <p className="font-bold text-stone-900" data-id="element-275">Jennifer K.</p>
                <p className="text-xs text-stone-500" data-id="element-276">Age 48, Austin</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-amber-100" data-id="element-277">
            <div className="flex gap-1 mb-4" data-id="element-278">
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-279" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-280" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-281" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-282" />
              <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-283" />
            </div>
            <p className="text-stone-700 mb-6 italic" data-id="element-284">
              "I spent{' '}
              <strong className="text-stone-900" data-id="element-285">
                $200/month on supplements
              </strong>{' '}
              that did nothing. This $17 guide gave me more results in one week
              than 2 years of expensive pills."
            </p>
            <div className="flex items-center gap-3" data-id="element-286">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center font-bold text-amber-700" data-id="element-287">
                P
              </div>
              <div data-id="element-288">
                <p className="font-bold text-stone-900" data-id="element-289">Patricia L.</p>
                <p className="text-xs text-stone-500" data-id="element-290">Age 55, Denver</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}